import {
    CREATE_SIGNUP,
    CREATE_SIGNUP_SUCCESS,
    CREATE_SIGNUP_ERROR,
    CREATE_SIGNUP_CLEAR_DATA
} from '../actions';

const INIT_STATE = {
    tenantData: null,
    signup: null,
    loading: false,
    isRightPanel: false,
    error: ''
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CREATE_SIGNUP:
            return { ...state, loading: true, isSagaExecuted:true, error: '', signup: action.payload.signup, isRightPanel: action.payload.isRightPanel };
        case CREATE_SIGNUP_SUCCESS:
            return { ...state, loading: false, isSagaExecuted:false, error: '' };
        case CREATE_SIGNUP_ERROR:
            return { ...state, loading: false, isSagaExecuted:false, error: action.payload.message };
        case CREATE_SIGNUP_CLEAR_DATA:
            return INIT_STATE;
        default: return { ...state };
    }
}
